/* Copyright (c) 2017 Backpack Health LLC */
/* eslint-disable no-param-reassign */

import { FuzzyDate } from '../../utilities/FuzzyDate';

export interface Diagnosis {
  getValue(): number;
  getDate(): FuzzyDate;
  set(date: FuzzyDate, value: number): void;
  remove(): void;
  hasValue(): boolean;
}

export default function (healthEntryCategoryState): Diagnosis {
  return {
    getValue: () => healthEntryCategoryState.diagnosis && healthEntryCategoryState.diagnosis.id,
    getDate: () => healthEntryCategoryState.diagnosis && healthEntryCategoryState.diagnosis.date,
    set(date, value) {
      healthEntryCategoryState.diagnosis = {
        id: value,
        date,
      };
    },
    remove() {
      healthEntryCategoryState.diagnosis = null;
    },
    hasValue: () => !!(healthEntryCategoryState.diagnosis && healthEntryCategoryState.diagnosis.id),
  };
}
